module.exports = __webpack_public_path__ + "43b09a732ce299f1cb664db5025e0839.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/phone.png
// module id = 1437
// module chunks = 249